// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/chevron-up-down.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chevron-up-down',
  version: 'solid',
  paths: [
    {
      d: 'M12.636 4.164a.9.9 0 0 0-1.272 0l-3.9 3.9a.9.9 0 0 0 1.272 1.272L12 6.072l3.264 3.264a.9.9 0 1 0 1.272-1.272l-3.9-3.9M7.464 15.936l3.9 3.9a.9.9 0 0 0 1.272 0l3.9-3.9a.9.9 0 1 0-1.272-1.272L12 17.928l-3.264-3.264a.9.9 0 0 0-1.272 1.272',
      fillRule: 'evenodd',
    },
  ],
}
